// eslint-disable-next-line no-restricted-imports
import sanitize, { defaults } from 'sanitize-html';

export const sanitizeHtml = (html: string): string =>
  sanitize(html, {
    allowedAttributes: {
      a: ['href', 'onclick', 'target', 'rel'],
      h2: ['id'],
      h3: ['style'],
      iframe: ['src', 'width', 'height', 'frameborder', 'allow', 'referrerpolicy', 'title', 'allowfullscreen'],
      img: ['src', 'alt', 'width', 'height', 'style'],
      p: ['style'],
      th: ['scope'],
      video: ['src', 'poster', 'width', 'height', 'controls', 'preload', 'autoplay', 'loop', 'muted'],
    },
    allowedTags: [
      ...defaults.allowedTags,
      'br',
      'iframe',
      'img',
      'video',
    ],
  });
